module.exports = "http://cdn.realive.com.ua/src/views/player/help/images/azs2.jpg";